var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M264.625 37h-13.25a.376.376 0 01-.375-.375V35.5a1.5 1.5 0 011.5-1.5h1.5v-1.625c0-.206.169-.375.375-.375h1.25c.206 0 .375.169.375.375V34h4v-1.625c0-.206.169-.375.375-.375h1.25c.206 0 .375.169.375.375V34h1.5a1.5 1.5 0 011.5 1.5v1.125a.376.376 0 01-.375.375zm-13.25 1h13.25c.206 0 .375.169.375.375V46.5a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-8.125c0-.206.169-.375.375-.375zM255 44.375a.376.376 0 00-.375-.375h-1.25a.376.376 0 00-.375.375v1.25c0 .206.169.375.375.375h1.25a.376.376 0 00.375-.375v-1.25zm0-4a.376.376 0 00-.375-.375h-1.25a.376.376 0 00-.375.375v1.25c0 .206.169.375.375.375h1.25a.376.376 0 00.375-.375v-1.25zm4 4a.376.376 0 00-.375-.375h-1.25a.376.376 0 00-.375.375v1.25c0 .206.169.375.375.375h1.25a.376.376 0 00.375-.375v-1.25zm0-4a.376.376 0 00-.375-.375h-1.25a.376.376 0 00-.375.375v1.25c0 .206.169.375.375.375h1.25a.376.376 0 00.375-.375v-1.25zm4 4a.376.376 0 00-.375-.375h-1.25a.376.376 0 00-.375.375v1.25c0 .206.169.375.375.375h1.25a.376.376 0 00.375-.375v-1.25zm0-4a.376.376 0 00-.375-.375h-1.25a.376.376 0 00-.375.375v1.25c0 .206.169.375.375.375h1.25a.376.376 0 00.375-.375v-1.25z",
    id: "tru-calendar-alt"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tru-calendar-alt",
    transform: "translate(-251 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAlt);
export default ForwardRef;